const { icons } = require('./constant');

const rules = {
	id: 'rules',
	title: 'Rules',
	type: 'collapse',
	icon: icons.IconCredit,
	children: [
		{
			id: 'ruleCategories',
			title: 'Rule Categories',
			type: 'item',
			url: '/ruleCategories',
			icon: icons.IconCredit,
			breadcrumbs: true,
		},
		{
			id: 'attributeGroups',
			title: 'Rule Attributes',
			type: 'item',
			url: '/attributeGroups',
			icon: icons.IconCredit,
			breadcrumbs: true,
		},
		{
			id: 'computedAttributes',
			title: 'Computed Attributes',
			type: 'item',
			url: '/computedAttributes',
			icon: icons.IconCredit,
			breadcrumbs: true,
		},
	],
};

export default rules;
